import * as React from "react";
import { useMutation } from "@tanstack/react-query";
import { Button, Dialog, Field, Textarea, useToast } from "@order-analyzer/ui";
import { api } from "../api.js";

export function FeedbackDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  const [message, setMessage] = React.useState("");
  const { push } = useToast();

  const submitMutation = useMutation({
    mutationFn: () => api.post("/feedback", { message: message.trim() }),
    onSuccess: () => {
      push({ tone: "success", title: "Danke für dein Feedback!", description: "Es wurde an die Administratoren übermittelt." });
      setMessage("");
      onClose();
    },
    onError: () => push({ tone: "error", title: "Feedback konnte nicht gesendet werden" }),
  });

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Feedback geben"
      description="Was läuft gut, was fehlt, was verwirrt? Dein Feedback geht direkt an die Administratoren."
      footer={
        <>
          <Button variant="outline" onClick={onClose}>
            Abbrechen
          </Button>
          <Button disabled={message.trim().length === 0 || submitMutation.isPending} onClick={() => submitMutation.mutate()}>
            {submitMutation.isPending ? "Wird gesendet ..." : "Senden"}
          </Button>
        </>
      }
    >
      <Field label="Dein Feedback" required>
        <Textarea
          rows={5}
          autoFocus
          placeholder="Beschreibe dein Anliegen ..."
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />
      </Field>
    </Dialog>
  );
}
